import React from "react";
import "../assets/css/servicios.css";
import grupoPersonas from "../assets/svg/Grupo_Personas.svg";
import edificio from "../assets/svg/edificio.svg";
import dolar from "../assets/svg/dolar.svg";

const Servicios = () => {
  return (
    <section className="servicios">
      <div className="title">
        <h2>NUESTROS SERVICIOS</h2>
        <p>Ofrecemos una gran cantidad de servicios</p>
      </div>
      <div className="cards-container">
        {/* Tarjeta 1 */}
        <div className="card">
          <div className="border"></div>
          <div className="content">
            <div className="logo">
              <div className="logo1">
                <img src={grupoPersonas} alt="Asesoria legal a personas" />
              </div>
              <div className="logo2-revelacion">
                <h2>ASESORÍA LEGAL A PERSONAS</h2>
                <span className="trail"></span>
              </div>
            </div>
            <div className="bottom-texts">
              <span className="bottom-text1">TORRES & TORRES</span>
              <span className="bottom-text2">FIRMA LEGAL</span>
            </div>
          </div>
        </div>

        {/* Tarjeta 2 */}
        <div className="card">
          <div className="border"></div>
          <div className="content">
            <div className="logo">
              <div className="logo1">
                <img src={edificio} alt="Asesoria legal a empresas" />
              </div>
              <div className="logo2-revelacion">
                <h2>ASESORÍA LEGAL A EMPRESAS</h2>
                <span className="trail"></span>
              </div>
            </div>
            <div className="bottom-texts">
              <span className="bottom-text1">TORRES & TORRES</span>
              <span className="bottom-text2">FIRMA LEGAL</span>
            </div>
          </div>
        </div>

        {/* Tarjeta 3 */}
        <div className="card">
          <div className="border"></div>
          <div className="content">
            <div className="logo">
              <div className="logo1">
                <img src={dolar} alt="onsultoria contable" />
              </div>
              <div className="logo2-revelacion">
                <h2>CONSULTORÍA CONTABLE</h2>
                <span className="trail"></span>
              </div>
            </div>
            <div className="bottom-texts">
              <span className="bottom-text1">TORRES & TORRES</span>
              <span className="bottom-text2">FIRMA LEGAL</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Servicios;
